import { Box, Paper, TextField } from '@mui/material'
import { styled } from '@mui/material/styles'

const SectionTitle = styled('h3')`
  margin: 0 0 10px 0;
  font-size: 0.95rem;
  font-weight: 600;
`

const TotalContainer = styled(Box)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
  font-size: 0.9rem;
  font-weight: 600;
`

const TabelaContainer = styled(Paper)`
  margin-top: 8px;
  box-shadow: none;
  border: 1px solid #e0e0e0;
`

const Campo = styled(TextField)`
  width: 100%;
`

export { SectionTitle, TotalContainer, TabelaContainer, Campo }
